import React, {Fragment, useEffect, useState, useRef} from 'react'
import {useLocation, useHistory} from "react-router-dom"
import {useDispatch} from "react-redux"

// Custom Component
import {makeSignIn} from "../../dataSource/signIn"


const store = require('store')

const SignIn = props => {
	const history = useHistory()
	const dispatch = useDispatch()

	const saveLoginInfo = async (token, refreshToken, loginInfo) => {
		store.set('site', loginInfo.data[0].site.site_seq)
		store.set('site_code', loginInfo.data[0].site.code)
		store.set('user_seq', loginInfo.data[0].user_seq)
		store.set('site_user_seq', loginInfo.data[0].site_user_seq)
		store.set('locale', 10001)
		store.set('username', loginInfo.data[0].username)
		store.set('fullname', loginInfo.data[0].fullname)
		store.set('user_category_code', loginInfo.data[0].company.category[0].category_code || '')
		store.set('access_token', token)
		store.set('refresh_token', refreshToken)
		store.set('loggedIn', true)
	}

	const handleSignIn = (inToken, inRefreshToken) => {
		try {
			makeSignIn("Bearer " + inToken).then(res => {
				dispatch({
					type: "FETCH_AUTH",
					data: res.data
				})

				saveLoginInfo(inToken, inRefreshToken, res).then(() => {
					history.push("/dashboard")
				})
			})
		}
		catch(error) {
			throw new Error(error)
		}
	}

	const useQuery = () => {
		return new URLSearchParams(useLocation().search)
	}

	const query = useQuery()

	useEffect(() => {
		const readToken = query.get("access_token")
		const readRefreshToken = query.get("refresh_token")
		
		handleSignIn(readToken, readRefreshToken)
	}, [])


	return (
		<Fragment></Fragment>
	)
}


export default SignIn